export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tags.vue?vue&type=template&id=42c6fe78&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/tags/tags.vue?vue&type=template&id=42c6fe78&
// module id = 1177
// module chunks = 0